import { Decimal } from "decimal.js";
import isEmpty from "lodash.isempty";
import { calculateFranchisePrice } from "./Helpers/util";

export const convertUnit = (value, multiplier) => {
    if (value === "0") {
        return value;
    }

    value = parseFloat(value);
    value = value * multiplier;
    // Changes to correct format, removes 0 at the end
    return value.toFixed(4).toString().replace(".", ",").replace(/0+$/, "");
};

export const unpackAreaCookie = (cookie) => {
    if (isEmpty(cookie)) {
        return;
    }

    const isDelivery = cookie?.area?.type === "delivery";
    let location = "";
    if (isDelivery) {
        const { address, housenumber, postcode, locality } = cookie.address;
        location = ` ${address} ${housenumber}, ${postcode} ${locality}`;
    } else {
        location = cookie?.area?.name?.split(" ")[1];
    }

    return {
        isDelivery,
        location,
    };
};

/**
 * Formatting prices for checkout
 * to handle cart object prices.
 *
 * @param {string} value
 * @param {number} minor_units
 * @param {string} currency
 * @param {number} quantity
 * @param {number} tax_value
 * @param {string} extract
 * @returns {string} formatted price
 */
export const formatCheckoutPrice = (
    value,
    minor_units,
    currency,
    quantity = 0,
    tax_value = 0,
    extract = 0
) => {
    value = parseFloat(value);
    value = value / Math.pow(10, minor_units);
    if (quantity) {
        value = value * quantity;
    }

    // creates gross values for display
    if (tax_value) {
        tax_value = parseFloat(tax_value);
        tax_value = tax_value / Math.pow(10, minor_units);
        value += tax_value;
    }

    // used in cases like removing compensation from the total price
    if (extract) {
        extract = extract.replace(" €", "");
        const removeValue = parseFloat(extract.replace(",", "."));
        value -= removeValue;
    }

    // Formats correctly for display
    value = value.toFixed(2).toString();
    return `${value.replace(".", ",")}${currency}`;
};

export const formatPrice = (value) => {
    if (!value) {
        return "0,00 €";
    }
    if (value || value === 0) {
        value = new Decimal(value);
        value = value.toFixed(2);
        return value.replace(".", ",") + " €";
    }
    return value;
};

export const weekdayNames = {
    1: "Montag",
    2: "Dienstag",
    3: "Mittwoch",
    4: "Donnerstag",
    5: "Freitag",
    6: "Samstag",
    7: "Sonntag",
};

export const nutrientNames = [
    "carbohydrate",
    "fat",
    "polyunsaturated_fatty_acid",
    "protein",
    "sugar",
    "energy",
];

export const filterNutrientsByNutrientsNames = (details) => {
    const filtered = Object.keys(details)
        .filter((key) => nutrientNames.includes(key))
        .reduce((obj, key) => {
            obj[key] = details[key];
            return obj;
        }, {});

    return filtered;
};

export const kcalToKj = (inKcal) => {
    if (inKcal === 0 || inKcal === null || inKcal === "~") return "~";
    return Math.round(inKcal * 4.184);
};

export const formatEnvCompensationValues = (co2, water) => {
    const formatedCo2 = getEnvCompensationFullAndTax(co2);
    const formatedWater = getEnvCompensationFullAndTax(water);

    return {
        single: calcSum(formatedCo2.single, formatedWater.single),
        double: calcSum(formatedCo2.double, formatedWater.double),
    };
};

const getEnvCompensationFullAndTax = (values) => {
    const { double, single } = values;

    const doubleGross = new Decimal(double);
    const singleGross = new Decimal(single);

    return {
        single: {
            full: singleGross,
        },
        double: {
            full: doubleGross,
        },
    };
};

const calcSum = (co2, water) => {
    const full = Decimal.add(co2.full, water.full);
    const tax = Decimal.add(co2.tax, water.tax);
    return {
        full: formatPrice(full),
        tax: formatPrice(tax),
    };
};

/**
 * Formats products ingredients for API
 * @param {array} ingredientType
 * @returns array
 */
export const prepareIngredients = ({ dressings, extras, basic }) => {
    let removedIngredient = null; // { name: string, id: number }

    const formattedDressings = dressings.map((ingredient) => {
        return {
            product_id: ingredient.product_id,
            quantity: ingredient.quantity,
        };
    });

    const formattedExtras = extras.map((ingredient) => {
        return {
            product_id: ingredient.product_id,
            quantity: ingredient.quantity,
        };
    });

    const formattedBasics = basic
        .map((ingredient) => {
            if (ingredient.quantity === 0) {
                removedIngredient = {
                    name: ingredient.name,
                    product_id: ingredient.product_id,
                };
            }
            if (ingredient.quantity > 1)
                return {
                    product_id: ingredient.product_id,
                    quantity: ingredient.quantity - 1,
                };
        })
        .filter(Boolean); // removes unchanged basic ingredients

    return {
        ingredients: [
            ...formattedBasics,
            ...formattedExtras,
            ...formattedDressings,
        ],
        comment:
            removedIngredient !== null
                ? `Ohne ${removedIngredient.name}`
                : null,
        removedIngredient:
            removedIngredient !== null ? removedIngredient.product_id : null,
    };
};

export const calculateDressingDisplayPrice = (dressing, dressingsArray) => {
    const cookie = window.cookie.get();

    const isFirst = dressingsArray.indexOf(dressing) === 0;
    if (isFirst && dressing.quantity === 1) return "free";
    const { quantity } = dressing;

    let { price } = dressing;
    if (cookie && cookie.area) {
        price = calculateFranchisePrice(cookie.area.id, dressing);
    }

    return formatPrice(price * (isFirst ? quantity - 1 : quantity));
};

export const selectedIngredientsQuantity = (state) => {
    let quantity = 0;

    state.map((ingredient) => {
        quantity += ingredient.quantity ? ingredient.quantity : 0;
    });
    return quantity;
};
